import {Http, URLSearchParams, RequestOptions} from '@angular/http';
import {ApplicationUser} from './../../services/ApplicationUser';
import {Observable} from "rxjs/Rx";
import {ListResponseModel, ResponseModel} from "../response/response.model";
import {Injectable} from "@angular/core";
import {ToasterService} from 'angular2-toaster/angular2-toaster';

@Injectable()
export class CommunicationService {

    private API_ROOT:string = '/communication';

    constructor(private http: Http, private toasterService: ToasterService) {}

    sendCall(phoneNumber: number) {
        const user = ApplicationUser.getInstance();

        if(!user.user.extension_number || user.user.extension_number === '')
            return this.toasterService.pop('error', 'Error', 'Please verify that profile/extension number is set properly');

        this.http.post(this.API_ROOT + '/call', {phone_number: phoneNumber})
            .map(r => r.json())
            .subscribe(() => {
                this.toasterService.pop('success', 'Success', 'Calling ' + phoneNumber);
            },
            (e) => {
                let errorData = JSON.parse(e._body);
                this.toasterService.pop('error', 'Error', errorData.message);
            }
        )

    }
}


// WEBPACK FOOTER //
// ./src/app/models/communication/communication.service.ts